<template>
    <router-link to="/" name="home" class="hidden" />
    <router-view />
</template>
<script>    export default ({ name: 'App' })    </script>
